import CardWrapper from '../../components/wrapper/card';
import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';

const ClientCallbackPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const query = new URLSearchParams(useLocation().search);
    const success = query.get('success');
    const message = query.get('message');

    useEffect(() => {
        if (success === '1') {
            navigate(`/app/client/${id}/integration`);
        }
    }, []);

    if (success === '1') {
        return <Box sx={{ p: 2 }}>You have successfully logged in!</Box>;
    }
    return <Box padding="15px">
        <CardWrapper>
          <Box display="flex" flexDirection="column" alignItems="center" gap="20px" justifyContent="center" height="84vh">
            <Typography variant="h3" fontWeight="bold" color="textSecondary">{message}</Typography>
            <Button variant="contained" onClick={() => navigate(`/app/client/${id}/integration`)}>Back To Integrations</Button>
          </Box>
        </CardWrapper>
    </Box>;
};

export default ClientCallbackPage;